import { getShipmentListInProgress, setShipmentFilters } from '@/redux/Savers/SaversActions';
import { updateShipmentStatusEffect } from '@/redux/Savers/SaversEffects';
import { setAppLoader, setFilterToggle, setShipmentModal } from '@/redux/common/CommonActions';
import { setSelectedShipments, setShipmentList } from '@/redux/shipment/ShipmentActions';
import { convertUserDayTimeToEST } from '@/utilz';
import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';
import CommonModal from '@/views/components/Modals/CommonModal';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import TrailerStatusSelector from '@/views/components/Selectors/TrailerStatusSelector';
import { memo, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import SaversShipmentGridView from './SaversShipmentGridView';
import { getShipmentDefaultFilters } from './constants';

const SaversShipmentContent = () => {
  const [statusModal, setStatusModal] = useState(false);
  const [shipmentValues, setShipmentValues] = useState({
    shipmentNo: '',
    shipmentkey: '',
    trailerRequestStatus: '',
    trailerRequestID: '',
    trailerNumber: '',
    status: '',
  });
  const isReset = true;
  const dispatch = useDispatch();
  const shipmentFilters = useSelector((state) => state.savers.shipmentFilters, shallowEqual);
  const selectedShipments = useSelector((state) => state.shipment.selectedShipments, shallowEqual);
  const shipmentList = useSelector((state) => state.savers.shipmentList);
  const companyId = useSelector((state) => state.auth.selectedCompany.companyId, shallowEqual);

  const handleShipmentClick = (shipmentKey) => {
    dispatch(setShipmentModal(shipmentKey));
    dispatch(setFilterToggle(false));
  };
  const onSelect = (id, remove) => {
    const selectedShipmentsLocal = [...selectedShipments];
    if (!remove) {
      selectedShipmentsLocal.push(id);
    } else {
      const index = selectedShipmentsLocal.indexOf(id);
      selectedShipmentsLocal.splice(index, 1);
    }
    dispatch(setSelectedShipments(selectedShipmentsLocal));
  };

  useEffect(() => {
    if (companyId) {
      dispatch(setSelectedShipments([]));
      const initialFilters = getShipmentDefaultFilters();
      initialFilters.CreatedDateFrom = convertUserDayTimeToEST(initialFilters.CreatedDateFrom, 'start');
      initialFilters.CreatedDateTo = convertUserDayTimeToEST(initialFilters.CreatedDateTo, 'end');
      dispatch(
        setShipmentFilters({
          ...initialFilters,
          pageNumber: 1,
        }),
      );
      dispatch(
        setShipmentList({
          data: [],
          progressing: true,
          isFirstTime: true,
          totalRecords: 0,
          latedelivery: 0,
          latepickup: 0,
          missingDocument: 0,
          pickupFailed: 0,
          trackingfailures: 0,
        }),
      );
    }
  }, [companyId]);

  const handleLoadMore = () => {
    dispatch(
      setShipmentFilters({
        ...shipmentFilters,
        pageNumber: (shipmentFilters?.pageNumber || 0) + 1,
      }),
    );
    dispatch(getShipmentListInProgress());
  };
  const totalPageCount = shipmentList?.totalPageCount || 0;

  const handleStatusUpdate = async () => {
    try {
      dispatch(setAppLoader(true));
      setStatusModal(!statusModal);
      const updateStatusPayload = {
        trailerRequestId: shipmentValues.trailerRequestID,
        shipmentkey: shipmentValues.shipmentkey,
        trailerRequestStatus: shipmentValues.trailerRequestStatus.toString(),
        shipmentStatus: shipmentValues.status.toString(),
      };
      await updateShipmentStatusEffect(updateStatusPayload);
      dispatch(
        setShipmentFilters({
          ...shipmentFilters,
          pageNumber: 1,
        }),
      );
      dispatch(getShipmentListInProgress({ isReset }));
      showNotification({
        type: NOTIFICATION_TYPES.SUCCESS,
        message: 'Status updated successfully!',
      });

      dispatch(setSelectedShipments([]));
      dispatch(setAppLoader(false));
    } catch (error) {
      console.log('Update status failed:', error);
      showNotification({
        type: NOTIFICATION_TYPES.ERROR,
        message: error.message,
      });
      dispatch(setAppLoader(false));
    }
  };

  return (
    <div className="h-100 pt-15 d-flex flex-direction-column">
      <>
        <SaversShipmentGridView
          handleLoadMore={handleLoadMore}
          isLoading={shipmentList.progressing}
          hasMore={shipmentList.progressing ? false : shipmentList?.data.length < totalPageCount}
          shipmentList={shipmentList.data}
          handleShipmentClick={handleShipmentClick}
          onSelect={onSelect}
          selectedShipments={selectedShipments}
        />
        <CommonModal
          className="vw-30 vh-40"
          open={statusModal}
          title="Update Status"
          okText="Update"
          cancelText="Cancel"
          onClose={() => {
            setStatusModal(!statusModal);
          }}
          onCancel={() => {
            setStatusModal(!statusModal);
          }}
          onOk={() => handleStatusUpdate()}
        >
          <div>
            <div className="mt-10">
              <SecondaryLabel>Trailer Number : {shipmentValues?.trailerNumber}</SecondaryLabel>
            </div>
            <div className="mt-10">
              <SecondaryLabel>Shipment Number : {shipmentValues?.shipmentNo} </SecondaryLabel>
            </div>
            <div className="mt-10">
              <SecondaryLabel>Trailer Request Status</SecondaryLabel>
              <TrailerStatusSelector
                id="selStatus"
                className="mt-2 w-100"
                placeholder="Trailer Request Status"
                value={shipmentValues.trailerRequestStatus || null}
                onChange={(value) => setShipmentValues((prev) => ({ ...prev, trailerRequestStatus: value }))}
              />
            </div>
          </div>
        </CommonModal>
      </>
    </div>
  );
};

export default memo(SaversShipmentContent);
